module.exports = __webpack_public_path__ + "assets/companyLogo.2acf7337.png";